import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class PropertyOptionCard extends Component {

  render() {
    const { image, title, content, text, link, onClick } = this.props

    return (
  
      <div className='property-option'>

        <img className='property-option__image' loading='lazy' src={image?.sourceUrl} alt="" />

        <span className='property-option__view'>{ text }</span>

        <div className='property-option__details'>

          <p className='title'>{ title }</p>

          <div className='copy' dangerouslySetInnerHTML={{ __html: content }} />

        </div>

        <Link className='property-option__link' to={link} onClick={onClick}></Link>

      </div>
    )
  }
}

PropertyOptionCard.defaultProps = {
  image: null,
  title: '',
  content: '',
  text: '',
  link: '',
  onClick: () => {},
}

export default PropertyOptionCard
